document.addEventListener('click', function (e) {
  const badge = e.target.closest('.jdgm-preview-badge');

  if (!badge) return;

  e.preventDefault();

  const target = document.querySelector('#judgeme_product_reviews');

  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
});